import { DropdownMenu } from "../../../Inputs";
import { ActionsProps } from "../../../Inputs/DropdownMenu";
import { AccountAPIKey } from "./__queries__/apiKeyQueries";
import { useDeleteAPIKeyModal } from "./DeleteAPIKeyModal";
import { useEditAPIKeyModal } from "./EditAPIKeyModal";

export const ActionButton = ({
  apiKey,
  existingNames,
  refetch,
}: {
  apiKey: AccountAPIKey;
  existingNames: Array<string>;
  refetch: () => void;
}) => {
  const [showEditModal] = useEditAPIKeyModal({
    apiKey,
    existingNames,
    refetch,
  });

  const [showDeleteModal] = useDeleteAPIKeyModal({ apiKey, refetch });

  const actions: Array<ActionsProps> = [
    {
      label: "Rename",
      onClick: showEditModal,
    },
    {
      label: "Delete",
      variant: "red",
      onClick: showDeleteModal,
    },
  ];

  return <DropdownMenu actions={actions} />;
};
